import React from 'react';

import { TextField, TextFieldProps } from '@mui/material';

type TextAreaProps = {
  /** 現在の値 */
  value: string;
  /** 値変更ハンドラ */
  onChange: (value: string) => void;
  /** 最大文字数 */
  maxLength: number;
  /** 表示行数（デフォルト: 6） */
  rows?: number;
  /** エラーメッセージ（指定がある場合は文字数カウントの代わりに表示） */
  errorMessage?: string;
} & Omit<TextFieldProps, 'value' | 'onChange' | 'multiline' | 'rows' | 'error' | 'helperText'>;

/**
 * 改行可能な TextArea コンポーネント。
 * 文字数カウントを helperText に常時表示する。
 * Notice/Info の内容フォームと同じ見た目を提供する。
 */
const TextArea: React.FC<TextAreaProps> = ({
  value,
  onChange,
  maxLength,
  rows = 6,
  errorMessage,
  ...rest
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const helperText = errorMessage || `${value.length}/${maxLength}`;

  const { sx, ...textFieldProps } = rest;

  return (
    <TextField
      {...textFieldProps}
      value={value}
      onChange={handleChange}
      multiline
      rows={rows}
      error={!!errorMessage}
      helperText={helperText}
      slotProps={{ htmlInput: { maxLength } }}
      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 }, ...sx }}
    />
  );
};

export default TextArea;
